const convertMinutesToHHMM = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  return `${String(hours).padStart(2, '0')}h${String(remainingMinutes).padStart(
    2,
    '0'
  )}`;
};

const convertHHMMToMinutes = (time: string): number => {
  const [hours, minutes] = time.split('h').map(Number);
  const totalMinutes = hours * 60 + minutes;

  return totalMinutes;
};

export { convertMinutesToHHMM, convertHHMMToMinutes };
